import { Box, Button, Dialog, Grid, Paper, Typography, TextField, MenuItem } from '@mui/material';
import { use, useContext, useEffect, useState } from 'react';
import { OrgAuthConfigPublicFragment, OrgAuthConfigType, OrgPublicFragment, Role } from '../lib/verid-api/verid-api-types';
import { OrgSignUpOrSignIn } from './OrgSignUpOrSignIn';
import { ClientLogger } from '../lib/client-logger';
import { useMultiAuth, useVeridApi } from '../lib/verid-api';
import { useNavigate } from 'react-router-dom';
import { useQueryPersistence } from './QueryPersistence';

interface IStyle {
  header?: any;
  container?: any;
  title?: any;
  subtitle?: any;
  containerBtnTop?: any;
  containerBtn?: any;
  btnPrimary?: any;
}

interface IProps {
  theme: any;
  onSigninSuccess?: () => void;
}

const DEBUG = true;

export function OrgAuth(props: IProps) {
  const { theme, onSigninSuccess } = props;
  const veridApi = useVeridApi();
  const multiAuthContext = useMultiAuth();
  const { authConfig, orgId, role, isAuthenticated } = multiAuthContext;
  const navigate = useNavigate();
  const { paramsForCurrentUser } = useQueryPersistence();

  useEffect(() => {
    DEBUG && ClientLogger.debug('OrgAuth', 'useEffect', { authConfig, orgId, role });
    if (authConfig) {
      switch (authConfig.authConfigType) {
        case OrgAuthConfigType.AWS_COGNITO: {
          // This page should not be shown since there is only one auth config available and we require a redirect
          DEBUG && ClientLogger.debug('OrgAuth', 'Redirecting to auth config URL', { authConfig });
          // Redirect to the auth config URL
          // wait 1 second before redirecting to allow the oidc client to set up
          // new Promise((resolve) => setTimeout(resolve, 2000)).then(() => {
          DEBUG && ClientLogger.debug('OrgAuth', 'calling cognitoSignIn');
          veridApi.cognitoSignIn();
          // });
        }
      }
    }
  }, [authConfig?.redirectUrl, authConfig?.clientId, authConfig?.authConfigType]);

  useEffect(() => {
    const params = paramsForCurrentUser();

    DEBUG && ClientLogger.debug('OrgAuth', 'useEffect isAuthenticated', { isAuthenticated, params });
    if (isAuthenticated) {
      DEBUG && ClientLogger.debug('OrgAuth', 'User is authenticated, NAVIGATING TO HOME', { params });
      // preserver query params if any
      navigate(params?.lastPath || '/', { state: { queryParams: params?.params } });
    }
  }, [isAuthenticated]);

  DEBUG && ClientLogger.debug('OrgAuth', 'render', { authConfig, orgId, role, multiAuthContext });
  if (authConfig) {
    switch (authConfig.authConfigType) {
      case OrgAuthConfigType.AWS_COGNITO: // fallthrough
      case OrgAuthConfigType.VERID_OPEN_ID: {
        return <div>Redirecting</div>;
      }
      case OrgAuthConfigType.VERID_USER_ID_AND_PASSWORD:
        return (
          <OrgSignUpOrSignIn
            authConfig={authConfig}
            orgId={orgId || ''}
            theme={theme}
            onSigninSuccess={() => {
              DEBUG && ClientLogger.debug('OrgAuth', 'onSigninSuccess', { onSigninSuccess });
              onSigninSuccess && onSigninSuccess();
            }}
          />
        );
      case OrgAuthConfigType.IDENTITY_PROVIDER:
        return (
          <Grid>
            <Typography color="primary" align="center">
              {authConfig.authConfigType} Not Supported
            </Typography>
          </Grid>
        );
    }
  }

  // Landing Page to Select Authentication Method
  return <></>;
}
